/**
 * Sentence-case a status or table token for display.
 * "FAIL" → "Fail", "UNKNOWN" → "Unknown", "not_run" → "Not run", "open" → "Open".
 * HTTP methods stay uppercase. Hashes, percents, paths, and mixed-case titles
 * are left alone so "Key rotation" does not become "key rotation".
 */
const KEEP_UPPER = /^(GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS)$/i;
const STATUS_TOKEN = /\b(NOT_RUN|NOT RUN|UNKNOWN|MISMATCH|PENDING|FAIL|PASS)\b/g;

function rewriteStatusTokens(value: string): string {
  return value.replace(STATUS_TOKEN, (token) => {
    if (token === "NOT_RUN" || token === "NOT RUN") return "Not run";
    return token.charAt(0) + token.slice(1).toLowerCase();
  });
}

export function displayLabel(value: string): string {
  const raw = value.trim();
  if (!raw) return raw;
  if (KEEP_UPPER.test(raw)) return raw.toUpperCase();
  const rewritten = rewriteStatusTokens(raw);
  if (/[0-9]/.test(rewritten) && /[%./:]/.test(rewritten) && rewritten === raw) return raw;
  const spaced = rewritten.replace(/_+/g, " ").replace(/\s+/g, " ");
  const hasLower = /\p{Ll}/u.test(spaced);
  const hasUpper = /\p{Lu}/u.test(spaced);
  if (hasLower && hasUpper) {
    return spaced.replace(/^\p{L}/u, (ch) => ch.toUpperCase());
  }
  return spaced.toLowerCase().replace(/^\p{L}/u, (ch) => ch.toUpperCase());
}
